<template>
  <div class="page-add">
    <div class="add-title">新增用户</div>
    <basic-form ref="basic" @addUser="addUser"></basic-form>
    
  </div>
</template>

<script>
import BasicForm from "./basicForm";
import { addUser } from "@/api/user";
import { setItem } from "@/utils/storage.js";

export default {
  components: { BasicForm },
  created() {

  },
  methods:{
    addUser() {
      let form = Object.assign({}, this.$refs["basic"].basicRuleForm);
      delete form.avatarUrls;
      form.supremeLeader =
        this.$refs["basic"].basicRuleForm.supremeLeader.join("|");
      
      // 当用户类型为管理员时进行二次确认
      if (form.userType == 0) {
        this.$confirm(
          '“管理员”类型用户必须至少配置一个角色权限，才可正常登录平台。<br/>提交成功后，请点击“权限设置”按钮，配置角色权限，使该用户可正常登录。',
          '系统提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            dangerouslyUseHTMLString: true
          }
        ).then(() => {
          this.submitUser(form);
        }).catch(() => {
          // 用户取消操作
          this.$message({
            message: '已取消提交',
            type: 'info'
          });
        });
      } else {
        // 非管理员类型直接提交
        this.submitUser(form);
      }
    },
    
    // 实际提交用户的方法
    submitUser(form) {
      addUser(form).then((res) => {
        if (!res || res.code != 0) return;
        setItem(this.REFRESH_FLAG, true);
        this.$message({
          message: "添加成功",
          type: "success",
        });
        setTimeout(() => {
          const message = form.userType == 1 ? "用户信息提交成功，待管理员审核通过后即可正常使用本系统。" : "待管理员审核通过后，请配置该用户的角色权限，配置角色权限后才可正常使用本系统。";
          this.$message({
            message,
            type: "success",
          });
        }, 2000);
        this.$router.back();
      });
    },
  },
  beforeDestroy() {
  },
};
</script>

<style lang="scss" scoped>
.segment {
  margin-top: 20px;
  margin-bottom: 20px;
  /deep/ .el-radio-button__inner {
    color: #96a1b2;
  }
  /deep/ .is-active .el-radio-button__inner {
    color: #ffffff;
  }
  /deep/ .el-radio-button__inner {
    width: 170px;
  }
}
</style>
